module.exports = __webpack_public_path__ + "img/shanghai doll.0c8406de.png";